import React, { useState } from 'react';

const AlertPop = ({ isSuccess, isServerError, onClick }) => {
  return (
    <section className={`alert_pop ${isSuccess === false ? 'dsp-b' : ''}`}>
      <div className="container align-c">
        <h3>{isServerError ? '작업이 지연되고 있습니다.' : '인증에 실패했어요!'}</h3>
        <div className="msg_txt mt-20">
          {isServerError ? (
            <>
              잠시 뒤 시도해 보세요.
              <br />
              요청 사용자 수가 많아 작업이 지연되고 있습니다.
            </>
          ) : (
            <>
              입력 하신 정보가 맞는지 확인하세요.
              <br />
              필요한 경우 다시 인증하기를 선택하세요.
            </>
          )}
        </div>
        <div className="btn_box">
          <button onClick={onClick} type="button" className="pop_close">
            다시 인증
          </button>
        </div>
      </div>
      <div className="black_stage"></div>
    </section>
  );
};

const AuthWaitContent = () => {
  return (
    <div className="info_wrap Padding-20 pt-80">
      <ul className="step_box">
        <li className="comp">
          <span className="ico_step"></span>
          <div>정보입력</div>
        </li>
        <li className="ing">
          <span className="ico_step"></span>
          <div>카카오인증</div>
        </li>
        <li>
          <span className="ico_step"></span>
          <div>인증완료</div>
        </li>
      </ul>

      <div className="mt-100 align-c">
        <div>
          <img src="/assets/images/talk_bi.svg" className="w-80" alt="카카오톡 로고" />
        </div>
        <div className="mt-20 fs-20 fw-e">
          카카오톡 앱에 도착한
          <br />
          인증 메시지를 먼저 확인하세요.
        </div>

        <div className="mt-30 bg-eee fs-16 font-666 Padding-20 br-15 lh-24">
          카카오톡에서 인증을 완료하셨나요?
          <br />
          아래 <strong className="font-black">“인증 완료하기”</strong> 버튼을 눌러주세요.
        </div>
      </div>
    </div>
  );
};

const AuthWaitTemplate = ({ isSuccess, isServerError, goNextStep }) => {
  const moveToPrevPage = () => {
    goNextStep(false);
  };

  return (
    <>
      <AlertPop isSuccess={isSuccess} isServerError={isServerError} onClick={moveToPrevPage} />
      <AuthWaitContent />
    </>
  );
};

export default AuthWaitTemplate;
